export const SITE_URL = "https://ospreyracing.com";
export const SITE_NAME = "Osprey Racing Team";
export const INSTAGRAM_URL = "https://instagram.com/mt_osprey_racing";
export const INSTAGRAM_HANDLE = "@mt_osprey_racing";
